import { JobseekerWorkexperienceModel } from '../shared/models/jobseeker-workexperience-model';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { JobseekerModel } from '@admin/jobseekers/shared/models/jobseeker-model';
import { JobseekerService } from '../shared/services/jobseeker.service';

@Component({
  selector: 'hr-jobseeker-work-experience-info',
  templateUrl: './jobseeker-work-experience-info.component.html',
  styleUrls: ['./jobseeker-work-experience-info.component.less'],
  standalone: false,
})
export class JobseekerWorkExperienceInfoComponent implements OnInit {
  constructor(private jobseekerService: JobseekerService) {}

  @Input()
  public jobseeker: JobseekerModel;

  public monthListShortMap: any;
  public pendingJobseekerWorkExperiencesMap: any; //TODO future

  public isWorkExperienceAddModeOn: boolean;
  public isWorkExperienceEditModeOn: boolean;

  public newWorkExperience: JobseekerWorkexperienceModel;

  public onAddWorkExperienceClick() {
    this.initNewWorkExperience();
    this.isWorkExperienceAddModeOn = true;
  }

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public onWorkExperienceUpdate() {
    this.isWorkExperienceAddModeOn = false;
    this.onUpdate.emit(true);
  }

  public onWorkExperienceCancel() {
    this.isWorkExperienceAddModeOn = false;
  }

  public onWithouExperienceClick() {
    this.jobseekerService
      .SetWithouWorkExperience(this.jobseeker.jobseekerId)
      .subscribe((r) => {
        this.onUpdate.emit(true);
      });
  }

  ngOnInit() {
    this.monthListShortMap = {}; //TODO temp
    this.pendingJobseekerWorkExperiencesMap = {}; //TODO temp
  }

  private initNewWorkExperience() {
    this.newWorkExperience = new JobseekerWorkexperienceModel();
    this.newWorkExperience.jobseekerId = this.jobseeker.jobseekerId;
    this.newWorkExperience.jobseekerWorkExperienceId = -1;
  }
}
